/**
 * This file is used to configure different app client for this project based on the URL
 */

import config from "../amplify_outputs.json";
import amplifyAppClients from "./appClientsConfig";
import { Amplify } from "aws-amplify";
import { signInWithRedirect } from "aws-amplify/auth";
import { parseAmplifyConfig } from "aws-amplify/utils";
import awsmobile from "../amplify_outputs.json";

/**
 * This function will consider the URL params and the
 */
export default function ConfigureApp() {
  // Get the provider from the URL. Should only consider if the URL is /auth/sign-in/<provider>...
  const urlRoute = window.location.pathname;
  const provider = window.location.pathname.split("/")[3];

  // Set the config when sign in with different provider
  ConfigureAmplify(provider);

  // Check the URL, if there is no callback, then do a federated sign in
  if (
    !urlRoute.includes("callback") &&
    Object.keys(amplifyAppClients).includes(provider)
  ) {
    signInWithRedirect({ provider: { custom: config.auth.user_pool_id } });
    //Auth.federatedSignIn({ customProvider: config.aws_user_pools_id });
  }
}

function ConfigureAmplify(provider: string) {
  let confData = amplifyAppClients.default;
  if (provider && Object.keys(amplifyAppClients).includes(provider)) {
    //@ts-ignore
    confData = amplifyAppClients[provider];
  }
  // Gen2 REST APIs live in amplify_outputs `custom.API`. Amplify.configure does
  // NOT auto-map them to `API.REST`, so wire them up manually (migration guide).
  // The keys carry the backend branch suffix (e.g. "BlingsAPI-gen2-master") but
  // the app calls them by bare name (NEW_REST_API = "BlingsAPI"). The API base
  // names never contain a dash, so take everything before the first one — this
  // survives dashed branch names, which the old single-token regex
  // (/-[^-]+$/) did not: it turned "BlingsAPI-gen2-master" into "BlingsAPI-gen2".
  const restApi = Object.fromEntries(
    Object.entries((awsmobile as any).custom?.API ?? {}).map(([name, cfg]) => [
      name.split("-")[0],
      cfg,
    ])
  );
  const baseConfig = parseAmplifyConfig(awsmobile);
  Amplify.configure({
    ...baseConfig,
    API: {
      ...baseConfig.API,
      REST: restApi as any,
    },
  });
}

export function CheckIfProviderExists(providerName: string) {
  return Object.keys(amplifyAppClients).includes(providerName);
}

//http://localhost:3102/auth/sign-in/?provider=sample
